<template>
  <NsiTable :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :canEdit="canEdit" />
</template>

<script>
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'NsiMpkStatuses',
    components: {
      NsiTable,
    },
    data() {
      return {
        pageTitle: 'Статус МПК',
        canEdit: false,
        apiRoute: 'nsiMpkStatus',
        cardName: 'NsiMpkStatusCard',
      };
    },
    mixins: [security],
    created() {
      this.checkPermissionAndRedirect(Constants.Permissions.NsiAccess);
      this.checkPermission(Constants.Permissions.NsiEdit).then((response) => {
        this.canEdit = response.data;
      });
    },
    methods: {},
  };
</script>
